module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAsBAMAAADY04YuAAAAGFBMVEUAAAD3sQD3sQD3sQD3sQD3sQD3sQD3sQAbOW3nAAAAB3RSTlMA73DAVzwfquEB+QAAACtJREFUOMtjKMcFiqgvNQoGITDGBUypnwAEcQERhlEwCAHu+KJ+2lDCBdQAhQyEzeY9TxgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/base/iconMenu.png
// module id = ioO1
// module chunks = 1